export default "__VITE_ASSET__CW_o42t1__"